import React, { useContext } from 'react';
import axios from 'axios';
import { DropdownMenu, DropdownItem } from 'reactstrap';
import { UserContext } from '../../../hooks/UserContext';
import { history } from '../../../history';
import * as Icon from 'react-feather';

const handleNavigation = (e, path) => {
  e.preventDefault();
  history.push(path);
};

const UserDropdown = () => {
  const { user, setUser } = useContext(UserContext);

  const setUserContext = async () => {
    return await axios
      .get('/api/auth/user')
      .then((res) => {
        setUser(res.data.currentUser);
        history.push('/login');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleLogoutClick = () => {
    axios
      .post('/api/auth/logout', { withCredentials: true })
      .then(() => {
        setUserContext();
      })
      .catch((error) => {
        console.log('logout error', error);
      });
  };

  return (
    <DropdownMenu right>
      {user.role === 'Client' ? (
        <DropdownItem
          tag="a"
          href="#"
          onClick={(e) => handleNavigation(e, '/account')}
        >
          <Icon.User size={14} className="mr-50" />
          <span className="align-middle">Edit Profile</span>
        </DropdownItem>
      ) : (
        <DropdownItem
          tag="a"
          href="#"
          onClick={(e) => handleNavigation(e, '/admin/settings')}
        >
          <Icon.Settings size={14} className="mr-50" />
          <span className="align-middle">Admin</span>
        </DropdownItem>
      )}
      <DropdownItem divider />
      <DropdownItem
        tag="a"
        href="/api/auth/logout"
        onClick={(e) => {
          e.preventDefault();
          handleLogoutClick();
        }}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

export default UserDropdown;
